module.exports = __webpack_public_path__ + "static/media/img1-1.fc0bdfab.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/banano/biosense/biomasa/img1-1.png
// module id = 1160
// module chunks = 3